/**
 *
 * editar e organizar os contactos
 *
 * @since 1.0.0
 *
*/

// ordenação do array de contactos por tipo e por primario primeiro
const compareContacts = ( a, b ) => {
    if ( a.type === b.type )
        return ( stringToBoolean( b.primary ) - stringToBoolean( a.primary ) );
    if ( a.type < b.type )
        return -1;
    if ( a.type > b.type )
        return 1;

    return 0;
};

// função que converte os valores do atributo primary para booleana.
const stringToBoolean = string => {
    if ( typeof string === 'string' ) {
        switch ( string.toLowerCase().trim() ) {
            case 'true': case '1': return true;
            case 'false': case '0': return false;
            default: return Boolean( string );
        }
    } else {
        switch ( string ) {
            case 1: return true;
            case 0: case null: return false;
            default: return Boolean( string );
        }
    }
};

export {
    compareContacts,
    stringToBoolean
};